import { IconButton } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import { UserOrg } from "src/types/organization";
import { User } from "src/types/user";

import Context from "../../context";

export default function Delete({ email, id, role }: UserOrg) {
	const { actions } = useContext(Context);
	const queryClient = useQueryClient();

	const user = queryClient.getQueryData<User>(["user"]);

	if (role === "ROLE_VUMI") return null;

	return (
		<>
			{user?.email !== email && (
				<IconButton onClick={() => actions.showDialog(id)}>
					<Iconify icon='material-symbols:delete' color='error.main' width={16} />
				</IconButton>
			)}
		</>
	);
}
